import type { CountryCode } from "@config/site/types";

const formatPostalCodeNL = (value: string) => {
    if (value.length > 4 && value.charAt(4) !== " ") {
        return `${value.substring(0, 4)} ${value.substring(4)}`;
    }
    return value?.toUpperCase();
};

const formatPostalCodeSE = (value: string) => {
    // Insert a space after the 3rd character (e.g., 123 45)
    if (value.length > 3 && value.charAt(3) !== " ") {
        return `${value.substring(0, 3)} ${value.substring(3)}`.toUpperCase();
    }
    return value?.toUpperCase();
};

const formatPostalCodePL = (value: string) => {
    if (!value) return "";
    if (value.length > 2 && value.charAt(2) !== "-") {
        return `${value.substring(0, 2)}-${value.substring(2)}`.toUpperCase();
    }
    return value;
};

const formatters: Partial<Record<CountryCode, (value: string) => string>> = {
    NL: formatPostalCodeNL,
    SE: formatPostalCodeSE,
    PL: formatPostalCodePL,
};

const defaultFormatter = (value: string) => {
    return value?.toUpperCase();
};

export const getPostalCodeFormatter = (country: CountryCode) => {
    return formatters[country] ?? defaultFormatter;
};
